export default __webpack_public_path__ + "static/media/paypal-card.3c2153ee.svg";